// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import eventProgrammeItemEntity from './entities/event-programme-item.json';
import eventProgrammeItemMenu from '../pages/event-programme-item/menu.json';
import eventProgrammeItemFullForm from '../pages/event-programme-item/forms/full.json';
import eventProgrammeItemContextForm from '../pages/event-programme-item/forms/context.json';
import eventProgrammeItemMiniForm from '../pages/event-programme-item/forms/mini.json';
import eventProgrammeItemLookupForm from '../pages/event-programme-item/forms/lookup.json';
import eventProgrammeItemTableView from '../pages/event-programme-item/views/table.json';
import eventProgrammeItemCardsView from '../pages/event-programme-item/views/cards.json';
import eventProgrammeItemCalendarView from '../pages/event-programme-item/views/calendar.json';
import eventProgrammeItemDashboardView from '../pages/event-programme-item/views/dashboard.json';

/** Тип запису «Пункт програми» зі сторінками пакета: меню, форми та подання з pages/event-programme-item/. */
export const eventProgrammeItemDefinition: IRecordTypeDefinition = {
  ...eventProgrammeItemEntity,
  views: assembleViewSet({
      table: eventProgrammeItemTableView,
      cards: eventProgrammeItemCardsView,
      calendar: eventProgrammeItemCalendarView,
      dashboard: eventProgrammeItemDashboardView,
  }),
  form: eventProgrammeItemFullForm,
  forms: { full: eventProgrammeItemFullForm, context: eventProgrammeItemContextForm, mini: eventProgrammeItemMiniForm, lookup: eventProgrammeItemLookupForm },
  menu: eventProgrammeItemMenu,
} as IRecordTypeDefinition;
